// VideoStatMUI.jsx
import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import clientConfig from '../../../client-config';

const VideoStatMUI = () => {
  const [rows, setRows] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${clientConfig.backendHOST}/reports/videoStat`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'x-auth-token': localStorage.token,
        },
      })
      .then((res) => {
        const raw = res.data;
        setRows(
          raw.map((item, index) => ({
            id: index,
            category: item.video?.VideoK?.kategoriaNev,
            title: item.video?.videoCim,
            year: item.Year,
            month: item.Month,
            views: 1, // from userId count
          }))
        );

        const aggregated = raw.reduce((acc, curr) => {
          const label = `${curr.video?.videoCim}`;
          acc[label] = (acc[label] || 0) + 1;
          return acc;
        }, {});

        const chart = Object.entries(aggregated).map(([name, value]) => ({
          name,
          value,
        }));

        setChartData(chart);
        setLoading(false);
      });
  }, []);

  const columns = [
    { field: 'category', headerName: 'Kategória', flex: 1 },
    { field: 'title', headerName: 'Videó', flex: 2 },
    { field: 'year', headerName: 'Év', width: 100 },
    { field: 'month', headerName: 'Hónap', width: 100 },
    { field: 'views', headerName: 'Nézettség', type: 'number', width: 120 },
  ];

  return (
    <Box className='content-block' sx={{ p: 3 }}>
      <Typography variant='h5' gutterBottom>
        Videó statisztika
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <Grid
          container
          spacing={3}
          display='flex'
          flexDirection='column'
          alignItems='center'
        >
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2, height: 400 }}>
              <Typography variant='subtitle1'>Nézettségi diagram</Typography>
              <ResponsiveContainer width='100%' height='100%'>
                <BarChart data={chartData} layout='vertical'>
                  <XAxis type='number' />
                  <YAxis type='category' dataKey='name' width={150} />
                  <Tooltip />
                  <Bar dataKey='value' fill='#1976d2' />
                </BarChart>
              </ResponsiveContainer>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ height: 400 }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                disableSelectionOnClick
              />
            </Paper>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default VideoStatMUI;
